rjm.ui.ChartBuilderFilterItemView = Backbone.View.extend(
  tagName: "li"
  className: "cohort-filter-item"

  events:
    "change .cbFilterOpSelector": "changeRestrictionOp"
    "change .filter-dimension": "changeColumn"
    "change .filter-value" : "restrictionValueChanged"

  initialize: (options) ->
    if not options or 
        not options.restriction or 
        not options.hasOwnProperty("restrictionIndex") or 
        not options.trend or
        not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderFilterItemView"

    _.bindAll this, "changeRestrictionOp", "changeColumn", "addCalendar", "restrictionValueChanged", "getDateOperators", "generateTemplateData", "render"
    
    #set incoming options
    @trend = options.trend
    @chartModel = options.chartModel
    @restriction = options.restriction
    @restrictionIndex = options.restrictionIndex

    if @restriction.get("op") is rjm.app.enums.comparisonOperator.IS or 
        @restriction.get("op") is rjm.app.enums.comparisonOperator.IS_NOT and 
        @restriction.get("right") is "NULL"
      @restriction.set(right: "[NULL]")

    #initilize local variables
    @sid = @restriction.get("left").get("sid")

    @listenTo @trend, "reset:slicers", @render

    return

  changeRestrictionOp: (e) ->
    e.preventDefault()
    newOp = @$(e.target).find("option:selected").val()
    opObject = rjm.app.enums.comparisonOperator[newOp]
    if opObject is rjm.app.enums.comparisonOperator.IS or opObject is rjm.app.enums.comparisonOperator.IS_NOT
      @restriction.set right: "[NULL]"
    else if @restriction.get('right') is "[NULL]" #not IS operator so clear null input
      @restriction.set right: "" 
    if (opObject is rjm.app.enums.comparisonOperator.IN or opObject is rjm.app.enums.comparisonOperator.NOT_IN) and not _(@restriction.get("right")).isArray()
      if @restriction.get("right")
        @restriction.set right: [@restriction.get("right")]
      else
        @restriction.set right: []
    if (opObject isnt rjm.app.enums.comparisonOperator.IN and opObject isnt rjm.app.enums.comparisonOperator.NOT_IN) and _(@restriction.get("right")).isArray() #if we are changing FROM an IN to another op, just pluck the first value from the IN array
      @restriction.set right: @restriction.get("right")[0] 
    @restriction.set op: opObject
    @render()
    return

  changeColumn: (e) ->
    e.preventDefault()
    sid = @$(e.target).find("option:selected").val()
    col = new rjm.model.LSColumn(sid: sid)
    #this guard is necessary because rendering a chart with IS/IS NOT and a blank value gives a 500
    @restriction.set right: ""  if @restriction.get("op") isnt rjm.app.enums.comparisonOperator.IS and @restriction.get("op") isnt rjm.app.enums.comparisonOperator.IS_NOT
    @restriction.set left: col
    @render()
    return

  changeDate: (newDate) ->
    dateTimeString = newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate()
    if newDate.getHours() is 0
      dateTimeString += ' 00'
    else
      dateTimeString += newDate.getHours()
    dateTimeString += ':'
    if newDate.getMinutes() is 0
      dateTimeString += "00"
    else
      dateTimeString += newDate.getMinutes()
    dateTimeString += ':'
    if newDate.getSeconds() is 0
      dateTimeString += "00"
    else
      dateTimeString += newDate.getSeconds()
    @$(".filter-value").val(dateTimeString).change()

  addCalendar: (date) ->
    @$('#datePicker').datepicker('setValue', date)
    @$('.filter-value').val(date)
    @$('#datePicker').datepicker().bind 'changeDate', (e) =>
      e.preventDefault()
      if e.viewMode is "days"
        @$('#datePicker').datepicker('hide')
      return
    @$('#datePicker').datepicker().bind 'hide', (e) =>
      e.preventDefault()
      @changeDate(e.date)
    return

  restrictionValueChanged: (e) ->
    e.preventDefault()
    #if it's a text field just get the value and set the value
    if @showTextField()
      @restriction.set right: @$(e.target).val()
    else #use select 2 methods to get data
      restValue = @$(e.target).select2("data")
      if _(restValue).isArray()
        @restriction.set right: _(restValue).map (value) -> value.id 
      else
        @restriction.set right: restValue.id

  getDateOperators: ->
    return {
      "GREATER_OR_EQUAL": rjm.app.enums.comparisonOperator.GREATER_OR_EQUAL,
      "GREATER": rjm.app.enums.comparisonOperator.GREATER,
      "LESS_OR_EQUAL": rjm.app.enums.comparisonOperator.LESS_OR_EQUAL,
      "LESS": rjm.app.enums.comparisonOperator.LESS,
      "EQUAL": rjm.app.enums.comparisonOperator.EQUAL,
      "NOT_EQUAL": rjm.app.enums.comparisonOperator.NOT_EQUAL,
      "IS": rjm.app.enums.comparisonOperator.IS,
      "IS_NOT": rjm.app.enums.comparisonOperator.IS_NOT
    }

  getGAOperators: ->
    return {
      "EQUAL": rjm.app.enums.comparisonOperator.EQUAL,
      "NOT_EQUAL": rjm.app.enums.comparisonOperator.NOT_EQUAL,
      "IN": rjm.app.enums.comparisonOperator.IN,
    }

  showTextField: ->
    (@restriction.get("left").isDateTime() or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.LIKE or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.NOT_LIKE or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.IS_NOT or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.IS or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.GREATER or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.GREATER_OR_EQUAL or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.LESS or 
      @restriction.get("op") is rjm.app.enums.comparisonOperator.LESS_OR_EQUAL or
      (@restriction.get("op") is rjm.app.enums.comparisonOperator.IN and @chartModel.isGAChart()))

  generateTemplateData: ->
    defer = $.Deferred()
    obj = {}
    sid = @restriction.get("left").get("sid")
    $.when(rjm.util.categoryValues.getCategoryDataForSid(sid, @chartModel.get('clientId'))).done (data) =>
      obj.selectedSid = sid
      obj.selectedOp = @restriction.get("op").serializedValue
      obj.rightValue = @restriction.get("right")
      obj.letter = encodedLetterString.indexToAlpha(@restrictionIndex)
      obj.index = @restrictionIndex
      obj.showCalendarIcon = (@restriction.get("left").isDateTime() and @restriction.get("op") isnt rjm.app.enums.comparisonOperator.IS and @restriction.get("op") isnt rjm.app.enums.comparisonOperator.IS_NOT)
      obj.showTextField = @showTextField()
      obj.textFieldIsReadOnly = (@restriction.get("op") is rjm.app.enums.comparisonOperator.IS_NOT or @restriction.get("op") is rjm.app.enums.comparisonOperator.IS or @restriction.get("left").isDateTime())
      obj.allowMultiSelect = (@restriction.get("op") is rjm.app.enums.comparisonOperator.IN or @restriction.get("op") is rjm.app.enums.comparisonOperator.NOT_IN)
      obj.columnNameProp = "name"
      obj.columnSidProp = "sid"
      obj.opPropertyName = "names"
      #special handling for operators if its a GA chart
      if @chartModel.isGAChart()
         obj.operationEnums = @getGAOperators()
         obj.opPropertyName = "gaNames"
         obj.allowMultiSelect = false
         obj.showTextField = (@restriction.get("op") is rjm.app.enums.comparisonOperator.IN)
      else if @restriction.get("left").isDateTime() 
        obj.operationEnums = @getDateOperators()  
      else 
        obj.operationEnums = rjm.app.enums.comparisonOperator
      obj.columnValues = data.categoryValues
      obj.tooManyValues = data.tooManyValues
      obj.columns = @trend.get("slicers")
      obj.selectedValues = (if _(obj.rightValue).isArray() then obj.rightValue else if obj.rightValue is "" then null else [obj.rightValue])
      obj.apiConnId = @chartModel.get('api_conn_id')
      obj.trid = @trend.getId()
      timeFrame = @chartModel.get('timeFrame').convertRangeToDateObjects()
      obj.start = timeFrame.start?.toString('yyyy-MM-dd')
      obj.end = timeFrame.end?.toString('yyyy-MM-dd')
      defer.resolve obj
    defer.promise()

  render: ->
    @$el.addClass('blocked loading')

    #pre-seed the selector with the pre-existing selected values from the chart we're loading up
    $.when(@generateTemplateData()).done (obj) =>
      @$el.html ich.chartBuilderFilterItem(obj)
      @$('[rel=tooltip]').tooltip()
      @$('.filter-dimension').find('select').select2 
        width: "resolve"
        minimumResultsForSearch: 6
      @$('.cbFilterOpSelector').find('select').select2 
        width: "resolve"
        minimumResultsForSearch: 100 #this being more than the number of options disables the search box
      
      if obj.showCalendarIcon
        @addCalendar(obj.rightValue)
      
      unless obj.showTextField
        #set up the select2 control
        options = 
          data: obj.columnValues
          containerCssClass: 'list-mode' # This is to give it that list style. 
          width: "resolve"
          multiple: obj.allowMultiSelect
          maximumSelectionSize: if obj.allowMultiSelect then false else 1
          placeholder: "Enter a Value"
          maximumInputLength: if @chartModel.isGAChart() then 125 else null #GA has a hard limit on filters at 128 characters. Our limit is 125 because we also add ^ and .* at the beggining and end for category values
          initSelection: (element, callback) ->
            values = element.val().split(',')
            selectedValueObjects = []          
            $(values).each( (index, value) => 
              if value isnt ''
                selectedValueObjects.push {id : value, text: value}
            )
            if obj.allowMultiSelect
              callback selectedValueObjects
            else
              callback selectedValueObjects[0]
          formatSelection: (object, container) ->
            return object.id          
          createSearchChoice: (term, data) ->
            if $(data).filter( -> return this.text.localeCompare(term) is 0 ).length is 0 
              return {id:term, text:term}
          formatNoMatches: (term) ->
            return "Too many values to display. Please start typing a value to search"
        if obj.columnValues.length is 0
          options.query = rjm.util.categoryValues.select2QueryFunction(obj.selectedSid, obj.apiConnId, obj.trid, obj.start, obj.end, @chartModel.get('clientId'))
            
        @$(".filter-value").select2 options

        #build the selected values (calls the initSelection event)
        if obj.selectedValues?.length > 0 and obj.selectedValues[0]?
          if obj.allowMultiSelect
            objects = _(obj.selectedValues).map (value) -> {id: value, text: value}
            @$(".filter-value").select2("data", objects)
          else
            @$(".filter-value").select2("data", {id: obj.selectedValues[0], text: obj.selectedValues[0]})

      #only unblock if the current trends slicer collection has the current sid. This makes sure we can't change this filter until
      #the trend's slicer collection is up to date for this trend.
      if @trend.get("slicers").containsSid @restriction.get("left").get("sid")      
        @$el.removeClass('blocked loading')
      #if we switch to a different column that inputs a value fire a change event on the input field
      if not _($(@el).find(".filter-value").val()).isEmpty()
        @$(".filter-value").change()
    
    return @
)